import * as types from "../constants/teamConstants"

const initialState = {
    isConfirmationModal: {
        modal: false,
        id: null,
        action: null
    },
    licencePackage: {},
    licenceTypes: [],
    licenceStartDate: null,
    licenceEndDate: null,
}

export default function TeamReducer(state=initialState, action) {
    switch(action.type) {
        case types.TEAM_IS_CONFIRMATION_MODAL:
            return {
                ...state,
                isConfirmationModal: action.payload.isConfirmationModal,
            }
        case types.SET_TEAM_CONTEXT:
            return {
                ...state,
                licencePackage: action.payload.licencePackage,
                licenceTypes: action.payload.licenceTypes,
                licenceStartDate: action.payload.licenceStartDate,
                licenceEndDate: action.payload.licenceEndDate,
            }
        case types.CLEAN_TEAM_CONTEXT:
            return initialState
        default:
            return state
    }
}